<template>
    <div class="content-wrapper">
      <div v-if="!checkCondition(careerPage)" class="hero position-relative pt-5">
        <div class="hero__item--content container">
          <div class="d-flex justify-content-end mb-3">
            <a :href="urlGenerator(loggedIn ? 'admin/dashboard' : 'admin/users/login')"
               class="btn btn-primary">{{ $t(loggedIn ? 'dashboard' : 'login') }}</a>
          </div>
        </div>
      </div>
      <hero ref="hero" v-else :is-candidate="isCandidate" :cover="jobPostCover" :icon="icon" :logged-in="loggedIn" :logo="logo"
            :pageSettingContent="vavContent.bodySection" :body-section="vavContent.bodySection" :active-preview="activePreview">
      </hero>

        <div class="editor-content">
            <div class="preview-content" style="padding: 2rem 14rem;">
                <div class="preview">
                    <div class="mb-5 cursor-pointer">
                        <a class="text-primary lead align-self-start" @click="redirectHomePage">
                            <app-icon name="chevron-left" />
                            {{ $t('back') }}
                        </a>
                    </div>
                    <div v-if="pageBlocks[pageView].header" class="text-center mb-5">
                        <h1 :style="`font-size: ${titleStyle.fontSize}; font-weight: ${titleStyle.fontWeight}; letter-spacing: ${titleStyle.letterSpacing}; color: ${titleStyle.color};`"
                            class="mb-4">
                            {{ $t(content.title) }}
                        </h1>
                    </div>
                    <div v-if="pageBlocks[pageView].body" class="editor-body">
                        <div v-for="(section,index) in content.bodySection"
                             class="mb-5">
                            <p :style="`font-size: ${descriptionStyle.fontSize}; font-weight: ${descriptionStyle.fontWeight}; letter-spacing: ${descriptionStyle.letterSpacing}; color: ${descriptionStyle.color};`"
                               v-html="purify(decode($t(section.headings)))">
                            </p>
                        </div>
                    </div>

                    <a :href="applyLink" class="btn btn-primary rounded-sm mb-4 text-white">
                            {{ $t('apply_now') }}
                    </a>

                  <div class="astrodivider"><div class="astrodividermask"></div><span><i>&#10038;</i></span></div>
                  <div class="container py-4">
                    <div class="row gy-4 gx-5">
                      <div class="col-lg-4 col-md-6">
                        <h5 class="h1" style="color: rgb(15, 55, 218);font-weight: bolder;">DE-VISA International</h5>

                        <p class="small text-muted mb-0">{{ companyText }}</p>
                      </div>
                      <div class="col-lg-2 col-md-6">
                        <h5 class="mb-3" style="color: rgb(15, 55, 218);">{{$t('important_links')}}</h5>
                        <ul class="list-unstyled text-muted">
                          <li><a href="#">KMK</a></li>
                          <li><a href="#">Goethe-Institut</a></li>
                          <li><a href="#">Jobsuche</a></li>
                        </ul>
                      </div>
                      <div class="col-lg-2 col-md-6">
                        <h5 class="mb-3" style="color: rgb(15, 55, 218);" >{{$t('our_services')}}</h5>
                        <ul class="list-unstyled text-muted">
                          <li><a href="#">{{$t('home')}}</a></li>
                          <li><a href="#">{{$t('about_us')}}</a></li>
                          <li><a href="#">{{$t('faq')}}</a></li>
                        </ul>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <h5 class="mb-3" style="color: rgb(15, 55, 218);" >{{$t('newsletter')}}</h5>
                        <p class="small text-muted">{{$t('newsletter_text')}}</p>
                        <form action="#">
                          <div class="input-group mb-3">
                            <input class="form-control" type="text"  aria-label="Recipient's username" aria-describedby="button-addon2">
                            <button class="btn btn-primary" id="button-addon2" type="button"><i class="fas fa-paper-plane"></i></button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import DetailsCard from './DetailsCard';
import {decode} from 'html-entities';
import {purify} from '../../Helpers/HTMLPurifyHelper.js'
import Hero from "../../Helpers/Editor/Hero";
import HeroDropdown from "../../Views/CareerPage/HeroDropdown.vue";

export default {
    name: "CandidateJobPost",
    props: {
      careerPage: {},
      data: {},
      applyLink: {},
      loggedIn: {
        type: Boolean,
        default: false
      },
      isCandidate: {
        type: Boolean,
        default: true
      }
    },
    components: {
        DetailsCard, Hero, HeroDropdown
    },
    data() {
        return {
            year: moment(moment.now()).format("YYYY"),
            viewType: 'desktop',
            activePreview: 'desktop',
            decode,
            purify,
            urlGenerator,
            vavContent : {
                  bodySection: [
                      {
                        "headings": "about_us",
                        "description": "about_us_description",
                        "id":"780c32dd-c3f1-6edb-fe82-9d22199bf31c"
                      },
                      {
                        "headings": "our_services",
                        "description": "our_services_description",
                        "id":"c81f6137-aa41-4233-0d8e-7fa9233075f2"

                      },
                      {
                        "headings": "jobs",
                        "description": "jobs_description",
                        "id":"f908756d-5f1a-10dc-cd33-db9243a45209"
                      },
                      {
                        "headings": "contact",
                        "description": "contact_us_description",
                        "id":"018fe9c6-d001-ccf1-4d72-25a386df5fec"
                      }
                ]
          },
        }
    },
    computed: {
        jobPostSetting() {
            if (typeof this.data['job_post_settings'] === 'string')
                return JSON.parse(this.data['job_post_settings']);
            return this.data['job_post_settings'];
        },
        content() {
            return this.jobPostSetting.content;
        },
        pageStyle() {
            return this.jobPostSetting.pageStyle;
        },
        pageBlocks() {
            return this.jobPostSetting.pageBlocks;
        },
        pageView() {
            return this.activePreview === 'desktop' ? 'defaultView' : 'mobileView'
        },
        titleStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'title')
        },
        subTitleStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'sub-title')
        },
        detailsStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'details')
        },
        headingsStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'headings')
        },
        descriptionStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'description')
        },
        icon() {
            return this.jobPostSetting.icon ? this.jobPostSetting.icon : urlGenerator(window.settings.company_icon)
        },
        logo() {
            return urlGenerator(window.settings.company_logo);
        },
        companyText() {
            return `${this.$t('copyright_text') + ' ' + this.year + ' ' + this.$t('by') + ' '} ${window.settings?.company_name ? window.settings.company_name : ''}`;
        },
        jobPostCover() {
          return urlGenerator(window.settings.job_post_cover);
        }
    },
    watch: {
        viewType: {
            handler: function (type) {
                this.toggleResponsivePreview(type)
            },
            immediate: true
        }
    },
    mounted() {
        this.checkViewType();
        window.onresize = () => {
            this.checkViewType();
        }
    },
    methods: {
        checkViewType() {
            this.viewType = window.innerWidth > 575 ? 'desktop' : 'mobile';
        },
        toggleResponsivePreview(previewType) {
            let preview = $('.preview-content .preview')
            if (previewType === 'desktop') {
                this.activePreview = 'desktop';
                preview.removeClass('mobile-preview');
                preview.addClass('desktop-preview');
            } else {
                this.activePreview = 'mobile';
                preview.removeClass('desktop-preview');
                preview.addClass('mobile-preview');
            }
        },
        redirectHomePage() {
            window.location.replace(urlGenerator('/'));
        },
        checkCondition(careerPage) {
          return true;
        },
      toggleModal() {
        this.$refs.hero.toggleModal();
      },

    }
}
</script>


<style scoped lang="scss">

a:hover, a:focus {
  text-decoration: none;
}


.form-control:focus {
  background: #212529;
}
footer h5 {
  color: #2850f0;
}


.astrodivider {
  margin:64px auto;
  width:400px;
  max-width: 100%;
  position:relative;
}

.astrodividermask {
  overflow:hidden; height:20px;
}

.astrodividermask:after {
  content:'';
  display:block; margin:-25px auto 0;
  width:100%; height:25px;
  border-radius:125px / 12px;
  box-shadow:0 0 8px #2850f0;
}
.astrodivider span {
  width:50px; height:50px;
  position:absolute;
  bottom:100%; margin-bottom:-25px;
  left:50%; margin-left:-25px;
  border-radius:100%;
  box-shadow:0 2px 4px #4fb39c;
  background:#fff;
}
.astrodivider i {
  position:absolute;
  top:4px; bottom:4px;
  left:4px; right:4px;
  border-radius:100%;
  border:1px dashed #68beaa;
  text-align:center;
  line-height:40px;
  font-style:normal;
  color:#2850f0;
}

</style>
